import type { UserOut as IUser } from '@repo/api-codegen/v2';
import { createMockableHook } from '@repo/common/utils/createMockableHook';
import {
	baseQueryHooksFactory,
	createQueryKeys,
	prefetchFunctionsFactory,
} from '../../factories';
import { filterFromListCacheByIds } from '../../utils';
import { fetchCurrentUser, useCurrentUser } from './useCurrentUser';

export const USERS_NAMESPACE = ['user'];

export const usersQueryKeyFactory = createQueryKeys(USERS_NAMESPACE);

const { prefetchUser, prefetchUserList } = prefetchFunctionsFactory(
	'user',
	usersQueryKeyFactory
);

export const filterUsersByIds = (ids: string[]) =>
	filterFromListCacheByIds<IUser>(usersQueryKeyFactory, ids);

const {
	useUser: useUserInternal,
	useUserInfiniteList,
	useUserList,
	useCreateUser,
	useDeleteUser,
	useUpdateUser,
	fetchUserList,
	updateUser,
} = baseQueryHooksFactory<IUser, 'user'>('user', usersQueryKeyFactory);

export const [useUser, MockUseUser] = createMockableHook(useUserInternal);

export {
	fetchCurrentUser,
	fetchUserList,
	prefetchUser,
	prefetchUserList,
	updateUser,
	useCreateUser,
	useCurrentUser,
	useDeleteUser,
	useUpdateUser,
	useUserInfiniteList,
	useUserList,
};
